import * as ACTION_TYPES from "./actionTypes";
import { secure } from "./API/faiz";
import { FAIZ_ACCESS_TOKEN } from "../constants/staticKeys";
import { errorMessageHandle } from "../constants/utilities";
import { toast } from "react-toastify";

const {
  UPDATE_HOTEL_PROPS,
  DELETE_HOTEL_PROPS,
  MERGE_HOTEL_PROPS
} = ACTION_TYPES;
export const updateHotelProp = (prop, value) => {
  return { type: UPDATE_HOTEL_PROPS, payload: [{ prop, value }] };
};
export const updateHotelProps = (payload) => {
  return { type: UPDATE_HOTEL_PROPS, payload: payload };
};
export const mergeHotelProps = (payload) => {
  return { type: MERGE_HOTEL_PROPS, payload: payload };
};
export const deleteHotelProp = (prop) => {
  return { type: DELETE_HOTEL_PROPS, payload: [{ prop }] };
};
export const deleteHotelProps = (payload) => {
  return { type: DELETE_HOTEL_PROPS, payload };
};

export const getHotels = (prop, page, param) => async (dispatch, getState) => {
  let url = "/hotel?page=" + page;
  let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
  dispatch({
    type: UPDATE_HOTEL_PROPS,
    payload: [{ prop: "isHotelLoading", value: true }],
  });
  secure(token)
    .get(url, { params: param })
    .then((response) => {
      dispatch({
        type: UPDATE_HOTEL_PROPS,
        payload: [{ prop, value: response.data.hotels }],
      });
    })
    .catch((error) => {
      let message;
      message = errorMessageHandle(error);
      toast.error(message);
    })
    .finally((f) => {
      dispatch({
        type: UPDATE_HOTEL_PROPS,
        payload: [{ prop: "isHotelLoading", value: false }],
      });
    });
};
const validateHotels = (hotels) => {
  let isValid = true;
  for (let i = 0; i < hotels.length; i++) {
    let message = "";
    if (hotels[i].name === "") {
      message = message + "Hotel name is mandatory. ";
      isValid = false;
    }

    if (message !== "") {
      message = message + "Check row " + (i + 1);
      toast.error(message);
    }
  }
  return isValid;
};
export const saveHotels = (hotels) => async (dispatch, getState) => {
  let editedHotels = hotels.data.filter((v) => {
    return v.edited === true;
  });
  if (editedHotels.length === 0) {
  } else if (validateHotels(editedHotels)) {
    let url = "/hotel";
    let param = { hotels: editedHotels };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_HOTEL_PROPS,
      payload: [{ prop: "isHotelSaving", value: true }],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        dispatch({
          type: UPDATE_HOTEL_PROPS,
          payload: [{ prop: "isHotelsTableEditable", value: false }],
        });
        for (let i = 0; i < hotels.length; i++) {
          dispatch({
            type: DELETE_HOTEL_PROPS,
            payload: [{ prop: "hotels.data." + i + ".edited" }],
          });
        }
        toast.success(response.data.msg);
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_HOTEL_PROPS,
          payload: [{ prop: "isHotelSaving", value: false }],
        });
      });
  } else {
    dispatch({ type: "" });
  }
};

export const deleteHotel = (hotel, index) => async (dispatch, getState) => {
  if (hotel.hasOwnProperty("id")) {
    let url = "/hotel";
    let param = { hotels: [hotel.id] };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_HOTEL_PROPS,
      payload: [{ prop: "hotels.data." + index + ".isDeleting", value: true }],
    });
    secure(token)
      .delete(url, { data: param })
      .then((response) => {
        dispatch({
          type: DELETE_HOTEL_PROPS,
          payload: [{ prop: "hotels.data." + index }],
        });
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_HOTEL_PROPS,
          payload: [
            { prop: "hotels.data." + index + ".isDeleting", value: false },
          ],
        });
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      });
  } else {
    dispatch({
      type: DELETE_HOTEL_PROPS,
      payload: [{ prop: "hotels.data." + index }],
    });
  }
};

export const createHotels = (hotels) => async (dispatch, getState) => {
  if (hotels.length === 0) {
    toast.error("No hotels to create");
  } else if (validateHotels(hotels)) {
    let url = "/hotel";
    let param = { hotels: hotels };
    let token = await localStorage.getItem(FAIZ_ACCESS_TOKEN);
    dispatch({
      type: UPDATE_HOTEL_PROPS,
      payload: [{ prop: "isHotelCreating", value: true }],
    });
    secure(token)
      .post(url, param)
      .then((response) => {
        dispatch({
          type: UPDATE_HOTEL_PROPS,
          payload: [
            { prop: "isNewHotelModalOpen", value: false },
            { prop: "newHotels", value: [] },
          ],
        });
        dispatch({
          type: MERGE_HOTEL_PROPS,
          payload: [{ prop: "hotels.data", value: response.data.hotels }],
        });
        toast.success(response.data.msg);
      })
      .catch((error) => {
        let message;
        message = errorMessageHandle(error);
        toast.error(message);
      })
      .finally((f) => {
        dispatch({
          type: UPDATE_HOTEL_PROPS,
          payload: [{ prop: "isHotelCreating", value: false }],
        });
      });
  } else {
    dispatch({ type: "" });
  }
};
